import React from "react";
import Header from "../Header";
import Footer from "../Footer";
import StickyButton from "../../StickyButton";

const AppLayout = ({ children }) => {
  return (
    <div className="app-layout">
      <div className="content">
        {children} {/* Le contenu des pages sera injecté ici */}
      </div>
      <Footer />
    </div>
  );
};

export default AppLayout;
